import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import AniEGsapA1 from './aniEGsapA1';
import AniEGsapB1 from './aniEGsapB1';
import { useGlobal } from '@/utils/useGlobal';

gsap.registerPlugin(ScrollTrigger);
export default function AnimationE({}: any) {
    const startH = 100;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const startNumScale = 0;
    const { useEffect } = useGlobal();

    return (
        <div className={`${css.animationE} animationE`}>
            <AniEGsapA1 />
            <AniEGsapB1 />
        </div>
    );
}
